export default __webpack_public_path__ + "static/media/S (18).1a75e781.png";